import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { Textarea } from '@/components/ui/textarea';
import { FileCode, Loader2 } from 'lucide-react';
import { toast } from 'sonner';

const docTypes = [
  { id: 'readme', label: 'README' },
  { id: 'api', label: 'API Docs' },
  { id: 'comments', label: 'Code Comments' },
];

export const DocGeneratorPanel = ({ docType, setDocType, codeSnippet, setCodeSnippet, docResult, onGenerate, loading }) => (
  <div className="max-w-3xl mx-auto space-y-6" data-testid="docs-panel">
    <Card className="card-tech p-8">
      <h2 className="text-2xl font-bold text-green-400 mb-2">
        <FileCode className="w-6 h-6 inline mr-2" /> Documentation Generator
      </h2>
      <p className="text-green-300 mb-6">Auto-generate README files, API docs, or add code comments.</p>
      <div className="space-y-4">
        <div>
          <label className="block text-green-400 text-sm font-semibold mb-2">Doc Type</label>
          <div className="grid grid-cols-3 gap-2">
            {docTypes.map(t => (
              <Button key={t.id} onClick={() => setDocType(t.id)}
                className={`${docType === t.id ? 'btn-primary' : 'btn-secondary'} text-sm`}
                data-testid={`doc-type-${t.id}`}>
                {t.label}
              </Button>
            ))}
          </div>
        </div>
        <Textarea value={codeSnippet} onChange={e => setCodeSnippet(e.target.value)}
          placeholder="Paste your code here or describe your project..."
          className="bg-black/50 border-green-500/30 text-green-300 font-mono text-sm min-h-32" rows={6} data-testid="doc-code-input" />
        <Button onClick={onGenerate} disabled={loading || !codeSnippet} className="btn-primary w-full py-4" data-testid="doc-generate-button">
          {loading ? <><Loader2 className="w-4 h-4 mr-2 animate-spin" /> Generating...</> : `Generate ${docType.toUpperCase()}`}
        </Button>
      </div>
      {docResult && (
        <div className="mt-6 p-4 bg-green-500/5 border border-green-500/20 rounded" data-testid="doc-result">
          <h4 className="text-green-400 font-semibold mb-2">Generated Documentation:</h4>
          <pre className="text-green-300 whitespace-pre-wrap text-sm leading-relaxed overflow-x-auto">{docResult}</pre>
          <Button onClick={() => { navigator.clipboard.writeText(docResult); toast.success('Copied!'); }}
            className="btn-secondary mt-4" data-testid="copy-doc-button">Copy to Clipboard</Button>
        </div>
      )}
    </Card>
  </div>
);
